import { Button, Grid, IconButton, Stack, Tooltip } from '@mui/material';
import { ProceedSaveLater, SubHeading } from './components';
import { Formik, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import UseRadioGroup from '../../lib/formik/Radio';
import { MFTextField } from '../../lib/formik';
import { Applicant, CountryTax } from '../../redux-store/types/api-types';
import { addressTypesMasters, USER_ROLES } from '../../utils/constant';
import {
  applicationComparison,
  convertTaxCountryDataToArray,
  getApplicantName,
  getCountryBasedOnStatus,
  getCurrentStep,
  navigateToNextStep,
  removeSingleQuote,
  saveForLater,
  statusRoleBased,
} from '../../utils/utilityFunctions';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { useHistory, useLocation } from 'react-router';
import { updateApplication } from '../../redux-store/actions/application';
import { FATCAValidationSchema } from '../../utils/schema';
import { Notes } from './components';
import { useSnackbar } from 'notistack';
import { mdmsCountriesList, nationaliyType } from '../../redux-store/types/mdms';
import { getNationalityList } from '../../redux-store/actions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { DataTable } from '../DataTable';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ConfirmationDialog } from '../commonComponents';
import { useFeatureToggles } from '../../utils/useDataMdms';

export type Values = {
  applicants: Partial<Applicant & { multipleCountryTax: Partial<CountryTax>[] }>[];
  saveType: string;
  countryDropdown: mdmsCountriesList[];
};

export const dummyCountryTax: Partial<CountryTax> = {
  id: 0,
  taxCountryName: '',
  taxID: '',
  idType: '',
};

const initialValues: Values = {
  applicants: [
    {
      typeOfAddressProvidedAtKRA: '',
      taxResidentOfAnyCountryOtherThanIndia: false,
      placeOfBirth: '',
      countryOfBirth: 'INDIA',
      countryOfNationality: 'INDIA',
      taxCountryName: '',
      taxID: '',
      idType: '',
      // taxCountryName2: '',
      // taxID2: '',
      // idType2: '',
      // taxCountryName3: '',
      // taxID3: '',
      // idType3: '',
      nameOfEntity: '',
      dateOfIncorporation: '',
      cityOfIncorporation: '',
      countryOfIncorporation: '',
      entityExcemptionCode: '',
      statusSubType: null,
      multipleCountryTax: [dummyCountryTax],
    },
  ],
  saveType: 'save and proceed',
  countryDropdown: [],
};

export const getColumns = (
  index: number,
  readOnly?: boolean,
  fieldDisabled?: boolean
): {
  header: string;
  label: string;
  renderEditDeleteCell?: (row: CountryTax) => JSX.Element;
  valueGetter?: (row: CountryTax) => string | number | boolean | undefined;
}[] => {
  return [
    {
      header: 'Tax country Name',
      label: 'taxCountryName',
      ...(!readOnly
        ? {
            renderEditDeleteCell: (row: CountryTax): JSX.Element => {
              return (
                <>
                  <Grid item xs={12} sx={{ '&.MuiGrid-item': { padding: 0 } }}>
                    <MFTextField
                      name={`applicants.${index}.multipleCountryTax.${row.id}.taxCountryName`}
                      placeholder="Enter Tax country Name"
                      disabled={fieldDisabled}
                    />
                  </Grid>
                </>
              );
            },
          }
        : { valueGetter: (row: CountryTax) => row.taxCountryName }),
    },
    {
      header: 'Tax ID',
      label: 'taxID',
      ...(!readOnly
        ? {
            renderEditDeleteCell: (row: CountryTax): JSX.Element => {
              return (
                <>
                  <Grid item xs={12} sx={{ '&.MuiGrid-item': { padding: 0 } }}>
                    <MFTextField
                      name={`applicants.${index}.multipleCountryTax.${row.id}.taxID`}
                      placeholder="Enter Tax ID"
                      disabled={fieldDisabled}
                    />
                  </Grid>
                </>
              );
            },
          }
        : { valueGetter: (row: CountryTax) => row.taxID }),
    },
    {
      header: 'ID Type',
      label: 'idType',
      ...(!readOnly
        ? {
            renderEditDeleteCell: (row: CountryTax): JSX.Element => {
              return (
                <>
                  <Grid item xs={12} sx={{ '&.MuiGrid-item': { padding: 0 } }}>
                    <MFTextField
                      name={`applicants.${index}.multipleCountryTax.${row.id}.idType`}
                      placeholder="Enter ID Type"
                      disabled={fieldDisabled}
                    />
                  </Grid>
                </>
              );
            },
          }
        : { valueGetter: (row: CountryTax) => row.idType }),
    },
  ];
};

const FatcaDetails = ({
  applicantName,
  index,
  applicant,
  nationalitiesMdmsResponse,
}: {
  applicantName: string;
  index: number;
  applicant: Partial<Applicant>;
  nationalitiesMdmsResponse: mdmsCountriesList[];
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const isFieldDisabled = [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { setValues, values } = useFormikContext<Values>();
  const [countryTaxToDelete, setCountryTaxToDelete] = useState<{
    id: number;
  } | null>(null);

  const AccessViewOrEditCell = (multipleTaxCountryLength: number) => [
    {
      header: '',
      renderCell: (row: CountryTax): JSX.Element => {
        return (
          <>
            {multipleTaxCountryLength > 1 && (
              <Stack
                sx={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  display: 'inline-flex',
                  maxWidth: '100%',
                  py: 1.5,
                  '& .MuiFormControl-root': { width: '100%', m: 0 },
                }}>
                <Tooltip title="Delete">
                  <IconButton
                    sx={{
                      ':hover': {
                        bgcolor: '#F4FCFC',
                      },
                    }}
                    onClick={() => {
                      setCountryTaxToDelete({ id: row.id });
                    }}>
                    <DeleteOutlineIcon color="error" fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Stack>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <SubHeading>FATCA Details of {applicantName} Applicant</SubHeading>
      <Grid item xs={12} sm={6}>
        <MFSelectField
          name={`applicants.${index}.typeOfAddressProvidedAtKRA`}
          label="Type of Address Provided At KRA *"
          items={addressTypesMasters.map((address) => ({ key: address, value: address }))}
        />
      </Grid>
      <Grid item xs={12}>
        <UseRadioGroup
          formLabel="Tax Resident of any country other than India *"
          name={`applicants.${index}.taxResidentOfAnyCountryOtherThanIndia`}
          items={[
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' },
          ]}
          value={applicant.taxResidentOfAnyCountryOtherThanIndia?.toString()}
          disabled={isFieldDisabled}
        />
      </Grid>
      {/* {applicant?.taxResidentOfAnyCountryOtherThanIndia?.toString() === 'true' && ( */}
      <>
        <Grid item xs={12} sm={6}>
          <MFTextField
            name={`applicants.${index}.placeOfBirth`}
            label="Place of Birth *"
            placeholder="Enter Place of Birth"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {/* <MFTextField
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            placeholder="Enter Country of Birth"
            disabled={isFieldDisabled}
          /> */}
          <SearchableSelect
            name={`applicants.${index}.countryOfBirth`}
            label="Country of Birth *"
            items={nationalitiesMdmsResponse.map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          {/* <MFTextField
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            placeholder="Enter Country of Nationality"
            disabled={isFieldDisabled}
          /> */}
          <SearchableSelect
            name={`applicants.${index}.countryOfNationality`}
            label="Country of Nationality *"
            items={getCountryBasedOnStatus(
              nationalitiesMdmsResponse,
              application?.applicants[index].statusSubType as string
            ).map((nationality) => ({
              key: nationality.name,
              value: nationality.name,
            }))}
            disabled={isFieldDisabled}
            searchFieldPlaceholder={'Search Country'}
          />
        </Grid>
        {applicant?.taxResidentOfAnyCountryOtherThanIndia?.toString() === 'true' && (
          <>
            <Grid item xs={12} sm={12} md={12}>
              <DataTable
                tableData={applicant?.multipleCountryTax as Partial<CountryTax>[]}
                tableHeader={[
                  ...getColumns(index, false, isFieldDisabled), // getColumns(applicantIndex, editOrReadOnlyView, fieldDisabled)
                  ...AccessViewOrEditCell(
                    (applicant?.multipleCountryTax as Partial<CountryTax>[])?.length
                  ),
                ]}
                noOfPages={1}
                renderAdditionalRow={true}
                tableBodyCustomStyles={{
                  '.MuiTableCell-root': {
                    borderBottom: 'none',
                  },
                }}
                tableHeaderCustomStyles={{
                  '.MuiTableCell-head': {
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: 14,
                    fontWeight: 500,
                    color: 'primary.main',
                    textAlign: 'left',
                    pl: 2,
                  },
                }}
                rowCustomStyles={{
                  '.MuiTableCell-root': {
                    py: 0,
                    overflowWrap: 'anywhere',
                    textAlign: 'left',
                    verticalAlign: 'top',
                  },
                }}
                boxStyles={{ minHeight: '0px', minWidth: 450, maxHeight: 'unset' }}
              />
            </Grid>
            {(applicant?.multipleCountryTax as Partial<CountryTax>[])?.length < 3 && (
              <Grid item xs={12}>
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  sx={{
                    color: 'primary.main',
                    fontWeight: 500,
                    fontSize: 14,
                    mt: 2,
                  }}
                  onClick={() =>
                    setValues({
                      ...values,
                      applicants: values.applicants.map((applicant, id) => {
                        if (id === index) {
                          return {
                            ...applicant,
                            multipleCountryTax: (
                              applicant?.multipleCountryTax as Partial<CountryTax>[]
                            )?.concat({
                              ...dummyCountryTax,
                              id: (applicant?.multipleCountryTax as Partial<CountryTax>[])?.length,
                            }) as Partial<CountryTax>[],
                          };
                        }
                        return applicant;
                      }),
                    })
                  }>
                  Add Tax Country
                </Button>
              </Grid>
            )}
          </>
        )}
        {/* <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.nameOfEntity`}
              label="Name of Entity"
              placeholder="Enter Name of Entity"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Date of Incorporation"
              inputLabelStyles={{
                transform: 'unset',
                fontSize: 14,
                fontWeight: 500,
                color: 'rgba(0,0,0,0.7)',
              }}
              maxDate={minDateForContributor()}
              name={`applicants.${index}.dateOfIncorporation`}
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              value={applicant.dateOfBirth || minDateForContributor().toString()}
              onChange={(newValue) => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant, ind) => {
                    if (index === ind) {
                      return {
                        ...applicant,
                        dateOfIncorporation: newValue?.toString(),
                      };
                    }
                    return applicant;
                  }),
                });
              }}
              textFieldStyles={{
                'label + &': {
                  mt: 4,
                },
                '& .MuiInputBase-root': {
                  border: '1px solid #DDEAF3',
                },
                '& .MuiOutlinedInput-root': {
                  position: 'relative',
                  backgroundColor: 'common.white',
                  border: '1px solid #DDEAF3',
                  fontSize: 16,
                  '&:hover': {
                    borderColor: 'primary.main',
                    '.MuiOutlinedInput-notchedOutline': {
                      border: 0,
                    },
                  },
                  '.MuiOutlinedInput-notchedOutline': {
                    border: 0,
                  },
                  '.MuiInputBase-input': {
                    p: '10px 12px',
                  },
                  '&:focus-visible': {
                    outline: 'none',
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.cityOfIncorporation`}
              label="City of Incorporation"
              placeholder="Enter City of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.countryOfIncorporation`}
              label="Country of Incorporation"
              placeholder="Enter Country of Incorporation"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <MFTextField
              name={`applicants.${index}.entityExcemptionCode`}
              label="Entity Exemption Code"
              placeholder="Enter Entity Exemption Code"
            />
          </Grid> */}
      </>
      {/* )} */}
      <ConfirmationDialog
        message={'Are you sure you want to delete tax country ?'}
        open={countryTaxToDelete !== null}
        setOpen={() => {
          setCountryTaxToDelete(null);
        }}
        onSave={() => {
          setValues({
            ...values,
            applicants: values.applicants.map((applicant, id) => {
              return id === index
                ? {
                    ...applicant,
                    multipleCountryTax: applicant.multipleCountryTax
                      ?.filter((countryTax) => {
                        return countryTax.id !== countryTaxToDelete?.id;
                      })
                      .map((countryTax, _i) => ({ ...countryTax, id: _i })),
                  }
                : applicant;
            }),
          });
          setCountryTaxToDelete(null);
        }}
        onCancel={() => {
          setCountryTaxToDelete(null);
        }}
      />
    </>
  );
};

export default function Fatca(): JSX.Element {
  const [fatcaDetails, setFatcaDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [mdmsCountriesList, setMdmsCountriesList] = useState<mdmsCountriesList[]>([]);
  const location = useLocation();
  const path = location.pathname;
  const { toggler } = useFeatureToggles();
  useEffect(() => {
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  useEffect(() => {
    const { applicants = [] } = application || {};
    (async function () {
      try {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        setMdmsCountriesList(nationalitiesMdmsMasters.countries);
        setFatcaDetails({
          ...fatcaDetails,
          applicants: applicants?.map((applicant) => {
            const modifiedMultipleCountryTax = convertTaxCountryDataToArray(applicant);
            return {
              typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
              taxResidentOfAnyCountryOtherThanIndia:
                applicant.taxResidentOfAnyCountryOtherThanIndia || false,
              placeOfBirth: applicant.placeOfBirth || '',
              countryOfBirth: applicant.countryOfBirth
                ? applicant.countryOfBirth.toUpperCase()
                : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
                ? ''
                : 'INDIA',
              countryOfNationality: applicant.countryOfNationality
                ? applicant.countryOfNationality.toUpperCase()
                : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
                ? ''
                : 'INDIA',
              taxCountryName: applicant.taxCountryName || '',
              taxID: applicant.taxID || '',
              idType: applicant.idType || '',
              nameOfEntity: applicant.nameOfEntity || '',
              dateOfIncorporation: applicant.dateOfIncorporation || '',
              cityOfIncorporation: applicant.cityOfIncorporation || '',
              countryOfIncorporation: applicant.countryOfIncorporation || '',
              entityExcemptionCode: applicant.entityExcemptionCode || '',
              statusSubType: applicant.statusSubType || null,
              multipleCountryTax: modifiedMultipleCountryTax?.length
                ? modifiedMultipleCountryTax
                : [dummyCountryTax],
            };
          }),
          countryDropdown: nationalitiesMdmsMasters.countries,
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleSubmit = async (values: Values) => {
    try {
      const {
        applicants: existingApplicants = [],
        id,
        applicant1ReferenceId = '',
        currentStep,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const { applicants, saveType } = values;
      const updatedPayload = existingApplicants.map((applicant, index: number) => {
        const {
          taxResidentOfAnyCountryOtherThanIndia = false,
          // dateOfBirth = '',
          dateOfIncorporation = '',
          multipleCountryTax = [],
          ...rest
        } = applicants[index];
        return {
          ...applicant,
          taxResidentOfAnyCountryOtherThanIndia:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false' ? false : true,
          // dateOfBirth: dateOfBirth ? dateOfBirth : null,
          dateOfIncorporation: dateOfIncorporation ? dateOfIncorporation : null,
          ...rest,
          placeOfBirth: removeSingleQuote(rest.placeOfBirth),
          taxCountryName:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(multipleCountryTax ? multipleCountryTax[0]?.taxCountryName : ''),
          taxID:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(multipleCountryTax ? multipleCountryTax[0]?.taxID : ''),
          idType:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(multipleCountryTax ? multipleCountryTax[0]?.idType : ''),
          taxCountryName2:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(multipleCountryTax ? multipleCountryTax[1]?.taxCountryName : ''),
          taxID2:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(multipleCountryTax ? multipleCountryTax[1]?.taxID : ''),
          idType2:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(multipleCountryTax ? multipleCountryTax[1]?.idType : ''),
          taxCountryName3:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(multipleCountryTax ? multipleCountryTax[2]?.taxCountryName : ''),
          taxID3:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(multipleCountryTax ? multipleCountryTax[2]?.taxID : ''),
          idType3:
            taxResidentOfAnyCountryOtherThanIndia.toString() === 'false'
              ? ''
              : removeSingleQuote(multipleCountryTax ? multipleCountryTax[2]?.idType : ''),
        };
      });
      const isSaveLater = saveType !== 'save and proceed';
      const checkApplication = applicationComparison(application, {
        ...application,
        applicants: updatedPayload,
        currentStep:
          !!currentStep &&
          currentStep >
            getCurrentStep(
              application?.applicationType || '',
              path,
              false,
              isSaveLater,
              application?.createdAt,
              toggler
            ) -
              1
            ? currentStep
            : getCurrentStep(
                application?.applicationType || '',
                path,
                false,
                isSaveLater,
                application?.createdAt,
                toggler
              ),
      });

      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...application,
              applicants: updatedPayload,
              status: statusRoleBased(role, application),
              currentStep: getCurrentStep(
                application?.applicationType || '',
                path,
                false,
                isSaveLater,
                application?.createdAt,
                toggler
              ),
              //!!currentStep && currentStep > 4 ? currentStep : Number(currentStep) + 1,
            },
            applicationId: id,
            ...(isSaveLater && { toastMessage: '' }),
          })
        );
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            isSaveLater,
            applicant1ReferenceId || '',
            application?.applicationType || '',
            false,
            application?.createdAt,
            toggler
          ),
          {
            id,
            applicant1ReferenceId,
          }
        );
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        history.push(
          navigateToNextStep(
            path,
            role,
            id || '',
            isSaveLater,
            applicant1ReferenceId || '',
            application?.applicationType || '',
            false,
            application?.createdAt,
            toggler
          ),
          {
            id,
            applicant1ReferenceId,
          }
        );
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  return (
    <Formik
      initialValues={fatcaDetails}
      onSubmit={handleSubmit}
      validate={(values: Values) => {
        try {
          validateYupSchema(values, FATCAValidationSchema, true, values);
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <Grid
          container
          rowSpacing={1}
          // columnSpacing={5}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
          }}
          component="form"
          noValidate
          onSubmit={handleSubmit}>
          <Notes
            displayContent={'FATCA Information is mandatory to disclose any Foreign Citizenship'}
          />
          {values.applicants?.map((applicant, index) => (
            <FatcaDetails
              applicantName={getApplicantName(index + 1)}
              index={index}
              key={index}
              applicant={applicant}
              nationalitiesMdmsResponse={mdmsCountriesList}
            />
          ))}
          <ProceedSaveLater
            saveLater={() => {
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            loader={loading}
            clickedButton={values.saveType}
          />
        </Grid>
      )}
    </Formik>
  );
}
